import { useCallback } from "react";
import { toast, ToastOptions } from "react-toastify";

const DEFAULT_TOAST_OPTIONS: ToastOptions = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

export const useToast = () => {
  const success = useCallback((message: string) => {
    toast.success(message, DEFAULT_TOAST_OPTIONS);
  }, []);

  const error = useCallback((message: string) => {
    toast.error(message, DEFAULT_TOAST_OPTIONS);
  }, []);

  const info = useCallback((message: string) => {
    toast.info(message, DEFAULT_TOAST_OPTIONS);
  }, []);

  const warning = useCallback((message: string) => {
    toast.warning(message, DEFAULT_TOAST_OPTIONS);
  }, []);

  return {
    success,
    error,
    info,
    warning,
  };
};
